// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AssetRef } from './assetRef.zod.ts';

export const RelationOut = zod.object({
  "asset": AssetRef,
  "direction": zod.enum(['outgoing', 'incoming']),
  "type": zod.string()
});

export type RelationOut = zod.input<typeof RelationOut>;
export type RelationOutOutput = zod.output<typeof RelationOut>;
